import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12h2","key":"svg-0"}],["path",{"d":"M20 12h2","key":"svg-1"}],["path",{"d":"M4 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-2"}],["path",{"d":"M16 12a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-3"}],["path",{"d":"M8 12h8","key":"svg-4"}]]

const IconCircuitSwitchClosed = createReactComponent('outline', 'circuit-switch-closed', 'CircuitSwitchClosed', __iconNode);

export default IconCircuitSwitchClosed;